import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { CUSTOM_ICONS } from './icons';

export function mcmEndpointToIcon(edp: string, visible: boolean): IconProp {
  switch (edp.split('-')[0].toLowerCase()) {
    case 'laptop':
      return visible ? 'laptop-mobile' : CUSTOM_ICONS['solid-laptop-mobile-slash'];
    case 'mobile':
      return visible ? 'mobile' : CUSTOM_ICONS['solid-mobile-slash'];
    case 'tv':
      return visible ? 'tv' : CUSTOM_ICONS['solid-tv-slash'];
    case 'plug':
      return visible ? 'plug' : CUSTOM_ICONS['solid-plug-slash'];
    case 'sign':
      return visible ? 'sign-posts' : CUSTOM_ICONS['solid-sign-posts-slash'];
    case 'calendar':
      return visible ? 'calendar-days' : CUSTOM_ICONS['solid-calendar-days-slash'];
    case 'newspaper':
      return visible ? ['fass', 'newspaper'] : CUSTOM_ICONS['sharp-solid-newspaper-slash'];
    case 'server':
      return visible ? 'server' : CUSTOM_ICONS['solid-server-slash'];
    default:
      return 'question';
  }
}
